var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#2F80ED",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9,10.79H47a.29.29,0,0,1,.29.28c.11,2.61.51,22.87-13,28.77v7.58H29.7V39.84S17,35.21,16.6,11.1A.3.3,0,0,1,16.9,10.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33,14.27h2.89a3.54,3.54,0,0,1,3.54,3.55v4a7.07,7.07,0,0,1-3.13,5.88l-8.9,6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.73,14.27h-3a3.54,3.54,0,0,0-3.54,3.55v4a7.07,7.07,0,0,0,3.13,5.88L23,34.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.89,
    y: 47.42,
    width: 14.62,
    height: 5.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.16,16.16l2.25,4.45a.15.15,0,0,0,.14.1l5,.72a.18.18,0,0,1,.1.32L36,25.2a.18.18,0,0,0-.06.17l.86,4.88a.19.19,0,0,1-.27.2l-4.49-2.32a.22.22,0,0,0-.16,0l-4.49,2.32a.19.19,0,0,1-.27-.2L28,25.37A.18.18,0,0,0,28,25.2l-3.61-3.45a.18.18,0,0,1,.1-.32l5-.72a.15.15,0,0,0,.14-.1l2.25-4.45A.18.18,0,0,1,32.16,16.16Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/ExperienceIcon.2a5fb7994e400d1c29a7b97de4457879.svg";
export { ForwardRef as ReactComponent };